export const API_BASE_URL = process.env.REACT_APP_SERVER_URL;
export const DEV_TOKEN = process.env.REACT_APP_DEV_TOKEN;
export const ACCESS_TOKEN_NAME = "XSRF-TOKEN";

export const USER_CURRENT_URL = "/api/v1/users/current";
export const USER_READ_URL = "/api/v1/users";
export const USER_FIND_URL = "/api/v1/users";
export const MEMBERS_LIST_URL = "/api/v1/users";
export const TASK_LIST_URL = "/api/v1/tasks";
export const RATING_URL = "/rating";
export const STATISTIC_URL = "/api/v1/tasks-daily-summary";
export const CALENDAR_URL = "/api/v1/calendar";
export const TASK_SLA_UPDATE_URL = "/api/v1/tasks/sla";
export const USER_SLA_URL = "/api/v1/user-sla";
